import FormattedMessage from 'I18n/components/FormattedMessage';
import { trackClickedLink } from '../utils/tracking/trackingEventUtils';
import { getProductsAndServicesCatalogUrl } from 'pricing-pages-lib/utils/urls';
import LinkWrapper from './common/LinkWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
const ProductAndServicesCatalogLink = ({
  children,
  onClick,
  trackingSource,
  section
}) => {
  const url = getProductsAndServicesCatalogUrl(section);
  const handleClick = e => {
    trackClickedLink({
      name: 'product-services-catalog',
      value: 'Product and Services Catalog',
      type: 'external',
      url,
      trackingSource
    });
    onClick === null || onClick === void 0 || onClick(e);
  };
  return /*#__PURE__*/_jsx(LinkWrapper, {
    onClick: handleClick,
    external: true,
    href: url,
    children: children || /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricingPage.productServicesCatalog"
    })
  });
};
export default ProductAndServicesCatalogLink;